/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';

export class SplitSeparatorComponent {

  @Input() thickness: number;
  @Output() notifyWillChangeSize: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('invisibleExtension', { static: false }) invisibleExtension: ElementRef;

  @HostListener('mousedown', ['$event'])
  onMousedown(event: MouseEvent): void {
    this.notifyWillChangeSize.emit(true);
    event.preventDefault();
  }
}
